var render = function render(){var _vm=this,_c=_vm._self._c;return _c('stats-widget',{attrs:{"title":_vm.$t('Released'),"icon":"mdi-check-circle-outline","color":"warning","stat":_vm.pausedPlanCount}})
}
var staticRenderFns = []

export { render, staticRenderFns }